import Vue from 'vue'
import { Drag, Drop } from 'vue-drag-drop'

Vue.component('Drag', Drag)
Vue.component('Drop', Drop)
